import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Layout, Menu, message, Row, Col, Drawer, Button } from 'antd';

import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BrowserView, MobileView } from 'react-device-detect';

import { withRouter } from 'react-router';
import { mutations } from '../../graphql/graphql';
import actions from '../../store/actions/actions';
import { canBeShowed } from '../../utils';
import _s from './Layouts.less';
import { UserOutlined, MenuOutlined } from '@ant-design/icons';

const { SubMenu } = Menu;
const { Header, Footer, Content } = Layout;

const hideFooterOnPages = ['/', '/plans'];

const LoggedLayout = props => {
  const [visible, setVisible] = useState(false);

  const [LogOut] = useMutation(mutations.LOG_OUT);
  const { user } = props;

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const handleLogOut = e => {
    if (e.key === 'LogOut') {
      LogOut()
        .then(res => {
          props.removeAuthUser();
          message.success('Logged out successfully');
          props.history.push('/');
        })
        .catch(err => console.log(err));
    }
  };

  const selected = location.pathname ? '/' + location.pathname.split('/')[1] : null;

  return (
    <Layout className="light" style={{ minHeight: '100vh', background: '#ffffff' }}>
      <Header className={_s.Header} style={{ background: '#ffffff', padding: '0 12px' }}>
        <MobileView>
          <Row justify="space-between">
            <Col>
              <Link to="/">
                <img src="/public/images/logo.png" alt="menu" className={_s.logo} />
              </Link>
            </Col>
            <Col>
              <Button type="default" onClick={showDrawer} icon={<MenuOutlined />} />
            </Col>
          </Row>
          <Drawer title="Menu" placement="right" onClose={onClose} visible={visible}>
            <Menu
              theme="light"
              mode="vertical"
              defaultSelectedKeys={['/']}
              selectedKeys={[selected]}
              style={{ lineHeight: '65px' }}
            >
              <Menu.Item key="/">
                <Link to="/">Plans</Link>
              </Menu.Item>
              <Menu.Item key="/my-plans">
                <Link to="/my-plans">My plans</Link>
              </Menu.Item>
              {canBeShowed(user, 'ADMIN') && (
                <Menu.Item key="/admin">
                  <Link to="/admin">Admin panel</Link>
                </Menu.Item>
              )}
              {canBeShowed(user, 'ADMIN') && (
                <Menu.Item key="/admin-assistant">
                  <Link to="/admin-assistant">Assistant</Link>
                </Menu.Item>
              )}
              <Menu.Item key="profile">
                <Link to="/profile">Profile</Link>
              </Menu.Item>
              <Menu.Item onClick={e => handleLogOut(e)} key="LogOut">
                Sign Out
              </Menu.Item>
            </Menu>
          </Drawer>
        </MobileView>
        <BrowserView>
          <Menu
            theme="light"
            mode="horizontal"
            defaultSelectedKeys={['/']}
            selectedKeys={[selected]}
            style={{ lineHeight: '65px' }}
          >
            <Menu.Item key="logo">
              <img src="/public/images/logo.png" className={_s.logo} alt="" />
            </Menu.Item>
            <Menu.Item key="/">
              <Link to="/">Plans</Link>
            </Menu.Item>
            <Menu.Item key="/my-plans">
              <Link to="/my-plans">My plans</Link>
            </Menu.Item>
            {canBeShowed(user, 'ADMIN') && (
              <Menu.Item key="/admin">
                <Link to="/admin">Admin panel</Link>
              </Menu.Item>
            )}
            {/* {canBeShowed(user, 'ADMIN') && (
              <Menu.Item key="/admin-assistant">
                <Link to="/admin-assistant">Assistant</Link>
              </Menu.Item>
            )} */}
            <SubMenu
              title={
                <>
                  {/* <Avatar size="medium" className={_s.UserAvatar} /> */}
                  <UserOutlined style={{ marginLeft: '10px' }} />
                  {/* <Icon type="down" style={{ marginLeft: '10px' }} /> */}
                </>
              }
              style={{ float: 'right' }}
            >
              <Menu.Item key="profile">
                <Link to="/profile">Profile</Link>
              </Menu.Item>
              <Menu.Item onClick={e => handleLogOut(e)} key="LogOut">
                Sign Out
              </Menu.Item>
            </SubMenu>
          </Menu>
        </BrowserView>
      </Header>
      <Content className={_s.ContentLogged}>{props.children}</Content>
      {!hideFooterOnPages.includes(selected) && (
        <Footer style={{ textAlign: 'center' }}>© 2024 HomeWiP Inc.</Footer>
      )}
    </Layout>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    loggedIn: state.auth.loggedIn
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      removeAuthUser: actions.removeAuthUser
    },
    dispatch
  );
};

LoggedLayout.propTypes = {
  user: PropTypes.object,
  loggedIn: PropTypes.bool.isRequired,
  removeAuthUser: PropTypes.func.isRequired
};

const connectedLoggedLayout = connect(mapStateToProps, mapDispatchToProps)(LoggedLayout);

export default withRouter(connectedLoggedLayout);
